import type { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';
import CustomCheckbox from '@/components/Checkbox';
import type { SymbolKey } from '@/entities/symbol';
import useSelectionFunctions from '@/features/SymbolSelector/hooks/useSelectionFunctions';

import type { SxProps, Theme } from '@mui/material';

const LegendCheckBox = ({
  series,
  checkboxStyles
}: {
  series: ExtendedSeriesOptionsType;
  checkboxStyles?: SxProps<Theme>;
}) => {
  const { isSymbolSelected, removeSymbolFromSelection, addSymbolToSelection } =
    useSelectionFunctions();
  const metadata = series?.custom;
  if (!metadata) return null;
  const symbol: SymbolKey = {
    Code: metadata.Code,
    Period: metadata.Period ?? '',
    PeriodType: metadata.PeriodType,
    TimeRef: metadata.TimeRef
  };

  const handleChange = () => {
    if (isSymbolSelected(symbol)) {
      removeSymbolFromSelection(symbol);
    } else {
      addSymbolToSelection(symbol);
    }
  };
  return (
    <CustomCheckbox
      checked={isSymbolSelected(symbol)}
      size='small'
      sx={{ ...checkboxStyles }}
      onChange={handleChange}
    />
  );
};
export default LegendCheckBox;
